/*eslint-disable no-useless-catch*/
// Importar dependencias
import ApiClient from "./ApiClient";

const productUrl = "payments/";

// Obtiene el secret de un payment intent de Stripe
async function getSecret(saleId, paymentMethod) {
  try {
    // Realizar petición
    const result = await ApiClient.get(
      productUrl + "secret?saleId=" + saleId + "&method=" + paymentMethod
    );
    return result.data;
  } catch (err) {
    // Regresa el error
    throw new Error(err.response.data.message);
  }
}

async function payWithMp(data) {
  try {
    const result = await ApiClient.post(productUrl + "pay-with-mp", data);
    return result.data;
  } catch (err) {
    // Regresa el error
    throw new Error(err.response.data.message);
  }
}

export default {
  getSecret,
  payWithMp
};
